module.exports = __webpack_public_path__ + "static/media/img-axum-thumb.a4f501e3.png";